<script setup lang="ts">
const { ecosystemLink } = useAppConfig()
const trackLinkClick = useTrackLinkClick()
const trackCtaClick = (): void =>
  trackLinkClick({
    pageLocation: 'Footer',
    linkType: 'Sendcloud Ecosystem',
    linkUrl: ecosystemLink,
  })

</script>

<template>
  <footer class="main-footer">
    <hr class="main-footer__hr">
    <p class="main-footer__row">
      <NuxtLink
        class="main-footer__link main-footer__item"
        target="_blank"
        :to="ecosystemLink"
        @click="trackCtaClick"
      >
        Interested in being in the App Store? Join our Partner Ecosystem now!
      </NuxtLink>
    </p>
    <p class="main-footer__row">
      <span class="main-footer__item">&copy; {{ new Date().getFullYear() }} Sendcloud </span>
      <span class="main-footer__divider">|</span>
      <NuxtLink
        class="main-footer__link main-footer__item"
        target="_blank"
        to="https://www.sendcloud.com/terms-conditions/"
      >
        Terms and conditions
      </NuxtLink>
      <span class="main-footer__divider">|</span>
      <NuxtLink
        class="main-footer__link main-footer__item"
        target="_blank"
        to="https://www.sendcloud.com/privacy-policy/"
      >
        Privacy & GDPR Policy
      </NuxtLink>
      <span class="main-footer__divider">|</span>
      <NuxtLink
        class="main-footer__link main-footer__item"
        target="_blank"
        to="https://www.sendcloud.com/data-processing-addendum/"
      >
        GDPR Terms of Processing
      </NuxtLink>
      <span class="main-footer__divider">|</span>
      <span class="main-footer__item">Chamber of Commerce: 66572959</span>
      <span class="main-footer__divider">|</span>
      <span class="main-footer__item">VAT number: NL856613897B01</span>
    </p>
    <LazyCookieMessage />
    <nav class="main-footer__social-media">
      <h2 class="sr-only">
        Social media links
      </h2>
      <NuxtLink
        target="_blank"
        class="main-footer__social-button"
        to="https://www.twitter.com/sendcloud"
      >
        <span class="sr-only">Twitter</span>
        <Icon name="fa6-brands:twitter" />
      </NuxtLink>
      <NuxtLink
        target="_blank"
        class="main-footer__social-button"
        to="https://www.facebook.com/sendcloud"
      >
        <span class="sr-only">Facebook</span>
        <Icon name="fa6-brands:facebook-f" />
      </NuxtLink>
      <NuxtLink
        target="_blank"
        class="main-footer__social-button"
        to="https://www.linkedin.com/company/sendcloud"
      >
        <span class="sr-only">LinkedIn</span>
        <Icon name="fa6-brands:linkedin-in" />
      </NuxtLink>
      <NuxtLink
        target="_blank"
        class="main-footer__social-button"
        to="https://www.instagram.com/sendcloud"
      >
        <span class="sr-only">Instagram</span>
        <Icon name="fa6-brands:instagram" />
      </NuxtLink>
    </nav>
  </footer>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/helpers' as *;

.main-footer {
  max-width: var(--app-layout-default-max-width);
  margin: var(--app-spacer-64) auto;
  padding: 0 var(--app-layout-default-page-padding);
  color: var(--app-color-footer-text);
  display: flex;
  flex-direction: column;
  align-items: center;

  .main-footer__item {
    padding: var(--app-spacer-8) var(--app-spacer-10);
  }

  .main-footer__link {
    @extend %footer-link-style;
  }
}

.main-footer__hr {
  width: 100%;
  border-top: 1px solid var(--app-color-footer-text);
  border-bottom: 0;

  @include min-width('lg') {
    display: none;
  }
}

.main-footer__row {
  text-align: center;
  margin: 0;

  * {
    display: inline-block;
  }
}

.main-footer__social-media {
  display: flex;
  gap: 16px;
  justify-content: center;

  a {
    width: 44px;
    font-size: set-rem-size(22px);
    color: var(--app-color-footer-text);
  }
}

.main-footer__social-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
}
</style>
